import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, lambda_type, unit_type, list_type, tuple_type, class_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { mapIndexed, singleton as singleton_1, ofArray, map, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { classNames, logii } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import * as react from "react";
import { effect } from "../Hooks/ClickOutside.js";
import { fold } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { uncurry, round } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { CSSProp, Prop, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { value as value_3 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { getMaterialIcon } from "../../ViewUtils.js";
import "../../../src/Components/StatefulFormFields/Dropdown.scss";


export class DropdownProps extends Record {
    constructor(Options, LabelText, PrimaryText, OnChange, MaxHeight) {
        super();
        this.Options = Options;
        this.LabelText = LabelText;
        this.PrimaryText = PrimaryText;
        this.OnChange = OnChange;
        this.MaxHeight = MaxHeight;
    }
}

export function DropdownProps$reflection() {
    return record_type("Components.StatefulFormFields.Dropdown.DropdownProps", [], DropdownProps, () => [["Options", list_type(tuple_type(string_type, class_type("Fable.React.ReactElement")))], ["LabelText", string_type], ["PrimaryText", string_type], ["OnChange", lambda_type(string_type, unit_type)], ["MaxHeight", option_type(string_type)]]);
}

export function DropdownProps_get_GetDefault() {
    return new DropdownProps(empty(), "", "", (str) => {
        logii(toText(printf("OnChange: %s. Needs override."))(str));
    }, void 0);
}

export const Dropdown = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_6, children_4, props_9, children_8;
    const menuVisibleState = react.useState(false);
    const maxDropDownRowWidthState = react.useState(void 0);
    const refArray = react.useRef([]);
    const options = map((tupledArg) => [tupledArg[0], tupledArg[1]], props.Options);
    const dropdownRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(dropdownRef, () => {
        menuVisibleState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    react.useEffect(() => {
        let newWidth_1, existingWidth_1, newWidth;
        const widthOpt = fold((acc, refElement) => {
            const clientRect = refElement.getBoundingClientRect();
            const width = clientRect.width;
            if (acc != null) {
                const existingWidth = acc;
                if (width > existingWidth) {
                    return width;
                }
                else {
                    return existingWidth;
                }
            }
            else {
                return width;
            }
        }, void 0, refArray.current);
        let newWidthOpt;
        const matchValue = [maxDropDownRowWidthState[0], widthOpt];
        newWidthOpt = ((matchValue[0] == null) ? ((matchValue[1] == null) ? (void 0) : ((newWidth_1 = matchValue[1], newWidth_1))) : ((matchValue[1] == null) ? (void 0) : ((existingWidth_1 = matchValue[0], (newWidth = matchValue[1], (newWidth > existingWidth_1) ? newWidth : (void 0))))));
        if (newWidthOpt != null) {
            const arg_1 = round(newWidthOpt + 20);
            maxDropDownRowWidthState[1](arg_1);
        }
    }, [props.Options]);
    const dropDownClasses = classNames(ofArray([["dropdown__dropdown", true], ["invisible", !(menuVisibleState[0])]]));
    const props_13 = toList(delay(() => append(singleton(new HTMLAttr(65, "dropdown")), delay(() => append(singleton(new Prop(3, dropdownRef)), delay(() => {
        let css;
        return ((maxDropDownRowWidthState[0]) != null) ? singleton((css = singleton_1(new CSSProp(395, value_3(maxDropDownRowWidthState[0]))), ["style", keyValueList(css, 1)])) : empty_1();
    }))))));
    const children_12 = [(children_6 = [react.createElement("span", {}, props.PrimaryText), (children_4 = [getMaterialIcon("expand_more")], react.createElement("span", {
        className: "dropdown__chevron",
    }, ...children_4))], react.createElement("div", {
        className: "dropdown__selected",
        onClick: (_arg_2) => {
            menuVisibleState[1]((value_2) => (!value_2));
        },
    }, ...children_6)), (props_9 = toList(delay(() => append(singleton(new HTMLAttr(65, dropDownClasses)), delay(() => {
        let css_1;
        return (props.MaxHeight != null) ? singleton((css_1 = singleton_1(new CSSProp(248, value_3(props.MaxHeight))), ["style", keyValueList(css_1, 1)])) : empty_1();
    })))), (children_8 = mapIndexed((i, _arg) => react.createElement("div", {
        className: "dropdown__option",
        ref: (ref) => {
            refArray.current[i] = ref;
        },
        onClick: (_arg_1) => {
            props.OnChange(_arg[0]);
        },
    }, _arg[1]), options), react.createElement("div", keyValueList(props_9, 1), ...children_8))), react.createElement("span", {
        className: "dropdown__label",
    }, props.LabelText)];
    return react.createElement("div", keyValueList(props_13, 1), ...children_12);
}, "Dropdown", uncurry(2, void 0), void 0, "Dropdown", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\StatefulFormFields\\Dropdown.fs", 99);

